import cx from "classnames";
import { get } from "lodash";
import { MultipleChoiceFieldType } from "../../types/feedbackFields.types";
import { FieldProps } from "../fields.types";

const MultipleCheckboxField = ({ field, data, onChange }: { field: MultipleChoiceFieldType } & FieldProps) => {
  const { _id, name, choices, maxChoices } = field;
  const id = _id || name;
  const values = get(data, id, []);

  const onLocalChange = (value: any, checked: boolean) => {
    if (!checked) {
      onChange(
        id,
        values.filter((v: string) => v !== value)
      );
      return;
    }

    values.push(value);
    onChange(id, values);
  };

  return (
    <div id={id}>
      {choices.map((choice, index) => {
        const { type, value, text } = choice;

        if (type === "header") {
          return (
            <label key={index} style={{ fontWeight: "bold", fontSize: 14 }}>
              {choice.text}
            </label>
          );
        }
        const inputValue = value || text;
        const isChecked = values?.includes(inputValue);
        return (
          <div key={index} className={cx("c-checkbox", field.choices.length >= 3 && "vertical")}>
            <label>
              <input
                type="checkbox"
                name={id}
                value={inputValue}
                checked={isChecked}
                disabled={!!maxChoices && values?.length >= maxChoices && !isChecked}
                onChange={(e) => onLocalChange(inputValue, e.target.checked)}
              />
              {text}
            </label>
          </div>
        );
      })}
    </div>
  );
};
export default MultipleCheckboxField;
